import * as React from 'react';
import FadeIn from '@/components/FadeIn/FadeIn';

const PRINCIPLES = [
  { header: 'Customer‑driven', body: 'We ship as soon as users ask.' },
  { header: 'Loved by teams', body: 'Retention > 95% and climbing.' },
  { header: 'Automation first', body: 'If it can be automated, we already did.' },
  { header: 'Transparent pricing', body: 'Outcome based pricing.' },
];

const WhyMarketBetter: React.FC = () => (
  <section className='bg-blue-900 py-12 md:pt-15 md:pb-24 rounded-2xl mx-4 md:mx-[30px] bg-[url(/images/about/about-numbers-bg.png)] bg-cover bg-no-repeat bg-bottom'>
    <div className='container mx-auto px-4 md:px-8 xl:px-25'>
      <FadeIn variant='down' delay={0.2}>
        <h2 className='text-4xl md:text-[54px] font-medium text-white mb-16 text-center'>
          Why teams pick MarketBetter
        </h2>
      </FadeIn>

      <div className='flex flex-col md:flex-row md:flex-wrap justify-center gap-8'>
        {PRINCIPLES.map((p, idx) => (
          <FadeIn
            key={idx}
            variant='up'
            delay={0.3 + idx * 0.1}
            className='flex-1 min-w-[260px] border-l-4 border-green-600 pl-4'
          >
            <div className='text-2xl md:text-3xl font-medium text-white mb-2'>{p.header}</div>
            <p className='text-white text-base leading-relaxed'>{p.body}</p>
          </FadeIn>
        ))}
      </div>
    </div>
  </section>
);

export default WhyMarketBetter;
